import {
  CAMPUS_ADD_BY_COURSES_FAILED,
  CAMPUS_ADD_BY_COURSES_REQ,
  CAMPUS_ADD_BY_COURSES_RESET,
  CAMPUS_ADD_BY_COURSES_SUCCESS,
  CAMPUS_DELETE_BY_COURSES_FAILED,
  CAMPUS_DELETE_BY_COURSES_REQ,
  CAMPUS_DELETE_BY_COURSES_SUCCESS,
  CREATE_COURSE_FAILED,
  CREATE_COURSE_REQ,
  CREATE_COURSE_RESET,
  CREATE_COURSE_SUCCESS,
  DELETE_COURSE_FAILED,
  DELETE_COURSE_REQ,
  DELETE_COURSE_RESET,
  DELETE_COURSE_SUCCESS,
  LIST_COURSES_FAILED,
  LIST_COURSES_REQ,
  LIST_COURSES_SINGLE_FAILED,
  LIST_COURSES_SINGLE_REQ,
  LIST_COURSES_SINGLE_RESET,
  LIST_COURSES_SINGLE_SUCCESS,
  LIST_COURSES_SUCCESS,
  TOTAL_COURSES_COUNT_FAILED,
  TOTAL_COURSES_COUNT_REQ,
  TOTAL_COURSES_COUNT_SUCCESS,
  UPDATE_COURSE_FAILED,
  UPDATE_COURSE_REQ,
  UPDATE_COURSE_RESET,
  UPDATE_COURSE_SUCCESS,
} from "../Constants/courseConstant";

export const COURSE_LISTS_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case LIST_COURSES_REQ: {
      return { Course_List_Loading: true };
    }

    case LIST_COURSES_SUCCESS: {
      return { Course_List_Loading: false, Courses_list: payload };
    }

    case LIST_COURSES_FAILED: {
      return { Course_List_Loading: false, Course_List_Error: payload };
    }

    default:
      return state;
  }
};

export const COURSES_TOTAL_DATA_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case TOTAL_COURSES_COUNT_REQ: {
      return { Courses_Total_Count_Loading: false };
    }
    case TOTAL_COURSES_COUNT_SUCCESS: {
      return { Courses_Total_Count_Loading: false, Courses_Count: payload };
    }
    case TOTAL_COURSES_COUNT_FAILED: {
      return {
        Courses_Total_Count_Loading: false,
        Courses_Total_Count_Error: payload,
      };
    }

    default:
      return state;
  }
};

export const COURSE_SINGLE_DATA_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case LIST_COURSES_SINGLE_REQ: {
      return { Course_Single_Data_Loading: true };
    }

    case LIST_COURSES_SINGLE_SUCCESS: {
      return { Course_Single_Data_Loading: false, Course_Single_Data: payload };
    }

    case LIST_COURSES_SINGLE_FAILED: {
      return {
        Course_Single_Data_Loading: false,
        Course_Single_Error: payload,
      };
    }

    case LIST_COURSES_SINGLE_RESET: {
      return {};
    }

    default:
      return state;
  }
};

export const COURSES_CREATE_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case CREATE_COURSE_REQ: {
      return { Course_Create_Loading: true };
    }
    case CREATE_COURSE_SUCCESS: {
      return { Course_Create_Loading: false, Course_Create_Success: payload };
    }

    case CREATE_COURSE_FAILED: {
      return { Course_Create_Loading: false, Course_Create_Error: payload };
    }

    case CREATE_COURSE_RESET: {
      return {};
    }

    default:
      return state;
  }
};

export const COURSE_LIST_UPDATE_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case UPDATE_COURSE_REQ: {
      return { Course_Update_Loading: true };
    }

    case UPDATE_COURSE_SUCCESS: {
      return { Course_Update_Loading: false, Course_Update_Success: payload };
    }

    case UPDATE_COURSE_FAILED: {
      return { Course_Update_Loading: false, Course_Update_Error: payload };
    }

    case UPDATE_COURSE_RESET: {
      return {};
    }

    default:
      return state;
  }
};

export const COURSE_DELETE_REDUCER = (state = {}, { type, payload }) => {
  switch (type) {
    case DELETE_COURSE_REQ: {
      return { Course_Delete_Loading: true };
    }

    case DELETE_COURSE_SUCCESS: {
      return { Course_Delete_Loading: false, Course_Delete_Success: payload };
    }

    case DELETE_COURSE_FAILED: {
      return { Course_Delete_Loading: false, Course_Delete_Error: payload };
    }
    case DELETE_COURSE_RESET: {
      return {};
    }

    default:
      return state;
  }
};

export const CAMPUS_ADD_BY_COURSES_REDUCER = (
  state = {},
  { type, payload }
) => {
  switch (type) {
    case CAMPUS_ADD_BY_COURSES_REQ: {
      return { Campus_Added_Loading: true};
    }
    case CAMPUS_ADD_BY_COURSES_SUCCESS: {
      return { ...state, Campus_Added_Success: payload };
    }
    case CAMPUS_ADD_BY_COURSES_FAILED: {
      return { Campus_Added_Loading: false, Campus_Added_Error: payload };
    }
    case CAMPUS_ADD_BY_COURSES_RESET: {
      return {};
    }
    default:
      return state;
  }
};

export const CAMPUS_DELETE_BY_COURSE = (state = {}, { type, payload }) => {
  switch (type) {
    case CAMPUS_DELETE_BY_COURSES_REQ: {
      return { Campus_DeleteAll_Loading: true };
    }
    case CAMPUS_DELETE_BY_COURSES_SUCCESS: {
      return {
        Campus_DeleteAll_Loading: false,
        Campus_DeleteAll_Success: payload,
      };
    }
    case CAMPUS_DELETE_BY_COURSES_FAILED: {
      return {
        Campus_DeleteAll_Loading: false,
        Campus_DeleteAll_Error: payload,
      };
    }
    default:
      return state;
  }
};
